import * as React from "react";
import State from "../model";
import { Dispatch } from "redux";
import { AppAction } from "../actions";
import * as Selector from "../selector";
import { connect } from "react-redux";
import { Row, Navbar, Nav, NavItem, PageHeader, Modal, Button, Table } from "react-bootstrap";
import { StateWithHistory } from "redux-undo";


interface GameSummaryProps {
    score: number;
    strikes: number;
}

interface GameSummaryState {
    showAbout: boolean;
    showRules: boolean;
}

class GameSummaryDisplay extends React.Component<GameSummaryProps, GameSummaryState> {
    constructor(props, context) {
        super(props, context);
        this.state = { showAbout: false, showRules: false };
    }

    private showAbout(): void {
        this.setState({showAbout: true, showRules: false});
    }

    private showRules(): void {
        this.setState({showAbout: false, showRules: true});
    }

    private handleClose(): void {
        this.setState({showAbout: false, showRules: false});
    }

    public render(): JSX.Element {
        return <div><Navbar>
            <Navbar.Header>
                <Navbar.Brand>
                    Lone Sevens
                </Navbar.Brand>
                <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
                <Nav>
                    <Navbar.Text>
                        by Joe Huber
                    </Navbar.Text>
                </Nav>
                <Nav>
                    <NavItem onClick={() => this.showAbout()}>
                        About
                    </NavItem>
                    <NavItem onClick={() => this.showRules()}>
                        Rules
                    </NavItem>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
        <PageHeader>Score: { this.props.score } /// Strikes: { this.props.strikes }</PageHeader>
        <Modal show={this.state.showAbout} onHide={() => this.handleClose()}>
            <Modal.Header>
                <Modal.Title>About Lone Sevens</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>
                    Lone Sevens was designed by Joe Huber.
                    It was inspired by Rattlebones, by Stephen Glenn,
                    and was designed to be played with components from Rattlebones.
                    Rattlebones was published by Rio Grande games, 
                    and is available at <a href="https://www.amazon.com/Rio-Grande-Games-434RGG-Rattlebones/dp/B00OYUZSCC/ref=sr_1_1?" target="_blank">Amazon</a> and other retailers.
                </p>
                <p>
                    More information about <a href="https://www.boardgamegeek.com/boardgame/150146/rattlebones" target="_blank">Rattlebones</a> and <a href="https://www.boardgamegeek.com/boardgame/253629/lone-sevens" target="_blank">Lone Sevens</a> is available on BoardGameGeek.

                </p>
                <p>
                    This web impelementation was written by Brian Hanechak.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => this.handleClose()}>Close</Button>
            </Modal.Footer>
        </Modal>
        <Modal show={this.state.showRules} onHide={() => this.handleClose()}>
            <Modal.Header>
                <Modal.Title>Playing Lone Sevens</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    A game for 1 player.
                </p>
                <p>
                    Requires a copy of Rattlebones to play
                </p>
                <p>
                    Set up five dice as standard dice to start the game.  
                    Get out the green victory point faces, the x2 faces, the arrow faces, and three star burst faces.  
                    The person whose birthdate is closest to July 7, 777 goes first.
                </p>
                <p>
                    Roll all five dice.  
                    If there is a combination of two or more dice that add to exactly seven, chose such a set.  
                    Replace one of the faces of these dice with a victory point face one lower than the number of dice.  
                    For example, if 6-5-4-2-1 is rolled, the player may chose the 6 and 1 (replacing one face with a 1 victory point face), the 5 and 2 (replacing one face with a 1 victory point face), or the 4, 2, and 1 (replacing one face with a 2 victory point face).  Dice showing anything other than pips have no value and may not be included in a set adding to seven.  If the 1 point faces run out, use the arrow faces; if the 2 point faces run out, use the x2 faces.  
                    The showing face on one other die, if it shows pips, may be replaced by a value one higher or one lower, within the usual 1-6 range.  
                    This is optional.
                </p>
                <p>
                    If no combination adds to exactly seven, replace one of the showing faces that does not show a star burst with a star burst.  One other face showing pips may be adjusted up or down by one.
                </p>
                <p>
                    The game ends when the third star burst face is placed.  Add up the victory point faces to determine your score.
                </p>
                <Table striped bordered>
                    <tbody>
                        <tr><td>less than 5</td><td>not so good</td></tr>
                        <tr><td>5-9</td><td>so-so</td></tr>
                        <tr><td>10-14</td><td>OK</td></tr>
                        <tr><td>15-19</td><td>good</td></tr>
                        <tr><td>20-24</td><td>excellent</td></tr>
                        <tr><td>25-29</td><td>wow!</td></tr>
                        <tr><td>30+</td><td>incredible!</td></tr>
                    </tbody>
                </Table>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={() => this.handleClose()}>Close</Button>
            </Modal.Footer>
        </Modal>
        </div>;
    
    }
}

const mapStateToProps = (state: StateWithHistory<State>, ownProps: {}) => {
    return {
        score: Selector.score(state.present),
        strikes: Selector.strikes(state.present)
    };
}

const mapDispatchToProps = (dispatch: Dispatch<AppAction>) => ({ });

export default connect(mapStateToProps, mapDispatchToProps)(GameSummaryDisplay);
    
